module.exports = __webpack_public_path__ + "img/logo_u1992-29.b05c10b7.png";